import { SET_PIP_CANVAS_EL, SET_PIP_EVENTS, SET_PIP_LOCAL_VIDEO_EL, SET_PIP_MAIN_VIDEO_EL, SET_PIP_RAISED_HANDS, SET_PIP_REQUEST_ANIM_ID, SET_PIP_SIZES, SET_PIP_STATUS, SET_PIP_STREAM_TO_LOCAL_VIDEO_EL, SET_PIP_STREAM_TO_MAIN_VIDEO_EL, SET_PIP_TILE_VIEW_CANVASES, SET_PIP_TILE_VIEW_LIST, SET_PIP_VIRTUAL_VIDEO_EL, UPDATE_USER_IN_TILE_VIEW_LIST } from './actionTypes';
import { STATUSES } from './constants';
import { isPipPlaying, isVideoReady, updateCanvas } from './function';
export function setPipEventsEmitted(state = {}) {
    return {
        type: SET_PIP_EVENTS,
        isPipEventsEmitted: state
    };
}
export function setPipRequestAnimateID(value = {}) {
    return {
        type: SET_PIP_REQUEST_ANIM_ID,
        requestAnimationId: value
    };
}
export function setPipSizes(data = {}) {
    return {
        type: SET_PIP_SIZES,
        dimensions: data
    };
}
export function setPipStatus(status = {}) {
    return {
        type: SET_PIP_STATUS,
        pipStatus: status
    };
}
export function setPipTileViewList(object = {}) {
    return {
        type: SET_PIP_TILE_VIEW_LIST,
        tileViewList: object
    };
}
export function updateUserInTileViewList(id, object) {
    return {
        type: UPDATE_USER_IN_TILE_VIEW_LIST,
        id,
        newData: object
    };
}
export function setPipTileViewCanvases(array = []) {
    return {
        type: SET_PIP_TILE_VIEW_CANVASES,
        tileCanvases: array
    };
}
export function setPipCanvasElement({ canvas, context }) {
    return {
        type: SET_PIP_CANVAS_EL,
        canvasEl: canvas,
        canvasCtx: context
    };
}
export function setPipStreamToMainVideoElement(stream, jitsiTrack) {
    return {
        type: SET_PIP_STREAM_TO_MAIN_VIDEO_EL,
        srcObject: stream,
        jitsiTrack
    };
}
export function setPipStreamToLocalVideoElement(stream) {
    return {
        type: SET_PIP_STREAM_TO_LOCAL_VIDEO_EL,
        srcObject: stream
    };
}
export function setPipVirtualVideoElement(el = {}) {
    return {
        type: SET_PIP_VIRTUAL_VIDEO_EL,
        virtualVideoEl: el
    };
}
export function setPipCopyMainVideoElement(el = {}) {
    return {
        type: SET_PIP_MAIN_VIDEO_EL,
        mainVideo: el
    };
}
export function setPipLocalVideoElement(el = {}) {
    return {
        type: SET_PIP_LOCAL_VIDEO_EL,
        localVideoElement: el
    };
}
export function setPipRaisedHands(array = {}) {
    return {
        type: SET_PIP_RAISED_HANDS,
        listUsersRaisedHands: array
    };
}
const baseSizes = {
    width: 0,
    height: 0,
    localVideoWidth: 0,
    localVideoHeight: 0,
    localVideoX: 0,
    localVideoY: 0
};
function createCanvasElement(canvasEl) {
    return (dispatch, getState) => {
        if (canvasEl) {
            return;
        }
        const canvas = document.createElement('canvas');
        const context = canvas.getContext('2d');
        canvas.id = 'canvas';
        canvas.width = baseSizes.width;
        canvas.height = baseSizes.height;
        dispatch(setPipCanvasElement({
            canvas,
            context
        }));
        document.body.appendChild(canvas);
    };
}
function createVirtualVideoElement(virtualVideoEl) {
    return (dispatch, getState) => {
        if (virtualVideoEl) {
            return;
        }
        const virtualVideo = document.createElement('video');
        virtualVideo.id = 'virtualVideo';
        virtualVideo.autoplay = true;
        virtualVideo.width = baseSizes.width;
        virtualVideo.height = baseSizes.height;
        dispatch(setPipVirtualVideoElement(virtualVideo));
        document.body.appendChild(virtualVideo);
    };
}
function createCopyMainVideoElement(mainVideo) {
    return (dispatch, getState) => {
        if (mainVideo) {
            return;
        }
        const mainVideoElement = document.createElement('video');
        mainVideoElement.autoplay = true;
        dispatch(setPipCopyMainVideoElement(mainVideoElement));
    };
}
function createCopyLocalVideoElement(mainVideo) {
    return (dispatch, getState) => {
        if (mainVideo) {
            return;
        }
        const localVideoElement = document.createElement('video');
        localVideoElement.autoplay = true;
        dispatch(setPipLocalVideoElement(localVideoElement));
    };
}
export function createPIP() {
    return (dispatch, getState) => {
        const state = getState();
        const { canvasEl, virtualVideoEl, mainVideo } = state['wildix/features/PiP'];
        baseSizes.width = 1140;
        baseSizes.height = 640;
        baseSizes.localVideoWidth = baseSizes.width / 6;
        baseSizes.localVideoHeight = baseSizes.height / 6;
        baseSizes.localVideoX = baseSizes.width - baseSizes.localVideoWidth;
        baseSizes.localVideoY = baseSizes.height - baseSizes.localVideoHeight;
        dispatch(setPipSizes({ ...baseSizes }));
        dispatch(createCanvasElement(canvasEl));
        dispatch(createCopyMainVideoElement(mainVideo));
        dispatch(createCopyLocalVideoElement(mainVideo));
        dispatch(createVirtualVideoElement(virtualVideoEl));
    };
}
export function enablePIP() {
    return async (dispatch, getState) => {
        const state = getState();
        const { isPipEventsEmitted, virtualVideoEl } = state['wildix/features/PiP'];
        if (!isPipEventsEmitted) {
            dispatch(setPipEventsEmitted(true));
        }
        dispatch(setPipStatus(STATUSES.LOADING));
        // Ensure the canvas is drawn and the stream is attached before trying to enter PiP.
        await updateCanvas({ state });
        const tryEnablePiP = async () => {
            if (isVideoReady(virtualVideoEl)) {
                try {
                    await virtualVideoEl.requestPictureInPicture();
                    dispatch(setPipStatus(STATUSES.PLAYING));
                }
                catch (error) {
                    console.warn('Failed to enable PiP:', error);
                    dispatch(setPipStatus(STATUSES.STOPPED));
                }
            }
        };
        if (virtualVideoEl?.readyState >= 1) {
            await tryEnablePiP();
        }
        else {
            let hasBeenCalled = false;
            const onReady = async () => {
                if (hasBeenCalled) {
                    return;
                }
                hasBeenCalled = true;
                // Clean up listeners immediately to prevent double calls
                virtualVideoEl?.removeEventListener('loadedmetadata', onReady);
                virtualVideoEl?.removeEventListener('canplay', onReady);
                await tryEnablePiP();
            };
            virtualVideoEl?.addEventListener('loadedmetadata', onReady);
            virtualVideoEl?.addEventListener('canplay', onReady);
        }
    };
}
export function disablePIP() {
    return async (dispatch) => {
        if (document.pictureInPictureElement) {
            try {
                await document.exitPictureInPicture();
            }
            catch (error) {
                console.warn('exitPictureInPicture failed during disablePIP', error);
            }
        }
        dispatch(setPipStatus(STATUSES.STOPPED));
    };
}
export function togglePIP() {
    return (dispatch, getState) => {
        const state = getState();
        if (!isPipPlaying(state)) {
            dispatch(enablePIP());
        }
        else {
            dispatch(disablePIP());
        }
    };
}
